import { render, staticRenderFns } from "./FormNotFound.vue?vue&type=template&id=ba8b57fc&scoped=true&"
import script from "./FormNotFound.vue?vue&type=script&lang=js&"
export * from "./FormNotFound.vue?vue&type=script&lang=js&"
import style0 from "./FormNotFound.vue?vue&type=style&index=0&id=ba8b57fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8b57fc",
  null
  
)

export default component.exports